import React from "react";
import Layout from "../../../components/layout";
import InfraNavbar from "../../../components/navbar-infra";
import { Link } from "gatsby";

const PricingPage = () => (
  <Layout title="Infra Pricing" hasSubNav={true}>
    <InfraNavbar selection="pricing" />
    <section className="section infra-pricing-section">
      <div className="container">
        <div className="columns" style={{ marginTop: "1.8rem" }}>
          <div className="column has-text-centered">
            <div className="callout">Leave no Server Un-Monitored</div>
          </div>
        </div>

        <div className="columns is-centered">
          <div className="column is-half">
            <div className="pricing-block">
              <div className="pricing-block-header">
                <div className="priceTop">100% Free</div>
                <p className="price">0</p>
                <div className="priceBottom">Unlimited Servers</div>
              </div>
              <div className="pricing-block-body">
                <ul>
                  <li>30 Day Data Retention</li>
                  <li>See &amp; compare data across multiple servers</li>
                  <li>Detailed Per Process Stats</li>
                  <li>Enterprise Grade Alerting</li>
                  <li>Disk, Memory and Network Stats</li>
                  <li>Inventory Monitoring</li>
                  <li>Database metric integrations</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="columns">
          <div className="column has-text-centered">
            <div className="calloutBottom">Thats Right. No Time Limits. 100% FREE!</div>
          </div>
        </div>

        <div className="columns is-centered" style={{ marginBottom: "1.8rem" }}>
          <div className="column is-half has-text-centered">
            <Link className="button is-black is-large has-text-weight-bold" to="/signup">
              Get Free DripStat Infra
            </Link>
          </div>
        </div>
      </div>
    </section>

    <section className="section">
      <div className="container infra-pricing-why-block">
        <div className="columns">
          <div className="column is-one-quarter">
            <img src="/img/logo/infra-logo.png" style={{ height: "44px" }} alt="" />
          </div>
          <div className="column is-three-quarters">
            <div className="question">
              How is this real? <br /> Why would I trust a free product for my Production Infrastructure?
            </div>
            <div className="answer">
              Details on our <a href="https://blog.dripstat.com/dripstat-infra-now-free-leave-no-server-unmonitored/">blog post</a>. <br />
              We know Free stuff is generally considered for 'Lite' usage. That is not the case here.
              <br />
              DripStat Infra is designed to go head-on with other commercial solutions.
            </div>
          </div>
        </div>
      </div>
    </section>
  </Layout>
);

export default PricingPage;
